import { Box } from "@chakra-ui/react"

export const ShipInfo = (props) => {
    return (
        <Box bg='linkedin.200' h='200px'>

        </Box>
    )
}